/**
 * Проверяем, слушаем ли мы такой компонент?
 *
 * @method
 * @private
 */
function _inList(component) {
  const self = this;

  return self.loggersList.hasOwnProperty(component);
}

export default _inList;
